import React from 'react';
import { Icon } from 'ksnm-common-ui/lib/Icon';
import type { ColumnInterface } from 'ksnm-common-ui/lib/Table2/Table.interface';

export const columns: ColumnInterface[] = [
  {
    title: 'Код версии отчетной формы',
    key: 'code',
    width: 200,
    fixedLeft: true,
  },
  {
    title: 'Код отчета',
    key: 'report_code',
    width: 160,
  },
  {
    title: 'Номер версии',
    key: 'version',
    width: 120,
  },
  {
    title: 'Наименование версии отчетности',
    key: 'name',
    width: 400,
  },
  {
    title: 'Ссылка на внешний код версии',
    key: 'external_version_code',
    width: 210,
  },
  {
    title: 'Дата начала действия версии',
    key: 'begin_date',
    width: 200,
  },
  {
    title: 'Дата окончания действия версии',
    key: 'finish_date',
    width: 200,
  },
  {
    title: 'Регламентированная версия отчета',
    key: 'regulated',
    width: 230,
    render: ({ value }) => value && <Icon name="check" />,
  },
];
